import '../styles/DigitalForm.css';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { FormField, FormSelect } from '../utils/formUtils';
import { fetchJsonFromS3Url } from '../api/s3_file_api.js';
import { getDigitalRequestJsonUrlApi } from '../api/digital_request_api';
import { openS3File } from '../utils/openS3File';

const DigitalFormView = () => {
    const { id } = useParams();
    const [values, setValues] = useState(null);
    const [loading, setLoading] = useState(true);
    const [errorMsg, setErrorMsg] = useState('');

    useEffect(() => {
        async function fetchForm() {
            setLoading(true);
            if (!id || isNaN(Number(id))) {
                setErrorMsg('קישור לא תקין. לא ניתן להציג את הטופס.');
                setLoading(false);
                return;
            }
            try {
                const { s3Key } = await getDigitalRequestJsonUrlApi(id);
                if (!s3Key) throw new Error('לא נמצא קובץ טופס');
                try {
                    const data = await fetchJsonFromS3Url(s3Key);
                    setValues(data);
                } catch (e) {
                    setValues(null);
                    setErrorMsg(e.message || 'הקובץ לא בפורמט תקין');
                }
            } catch (err) {
                setValues(null);
                setErrorMsg(err.message || 'שגיאה בטעינת הטופס');
                console.error('Error fetching form:', err);
            } finally {
                setLoading(false);
            }
        }
        fetchForm();
    }, [id]);

    if (loading) return <div>טוען טופס...</div>;
    if (errorMsg) return <div style={{ color: '#d81b60', textAlign: 'center' }}>{errorMsg}</div>;
    if (!values) return <div>לא נמצא טופס</div>;

    return (
        <div className="digital-form">
            <h1>צפייה בטופס דיגיטלי</h1>
            <form className="digital-form-view" style={{ pointerEvents: 'none', opacity: 1 }}>
                <div className="digital-form-sections">
                    {/* פרטי המבקש
                    <div className="digital-form-section">
                        <h2>פרטי המבקש</h2>
                        <FormField label="שם פרטי:" name="firstName" value={values.firstName || ''} readOnly />
                        <FormField label="שם משפחה:" name="lastName" value={values.lastName || ''} readOnly />
                        <FormField
                            label={values.idType === 'passport' ? "מספר דרכון:" : "תעודת זהות:"}
                            name="idNumber"
                            value={values.idNumber || ''}
                            readOnly
                        />
                        <FormField label="טלפון/פלאפון:" name="phone" value={values.phone || ''} readOnly />
                        <FormField label="כתובת:" name="address" value={values.address || ''} readOnly />
                        <FormField label="הקשר לנתמך:" name="relation" value={values.relation || ''} readOnly />
                        <FormSelect label="האם ידוע לנתמך על הגשת הבקשה?" name="informed" value={values.informed || ''} readOnly options={[{ value: '', label: 'בחר' }, { value: 'yes', label: 'כן' }, { value: 'no', label: 'לא' }]} />
                    </div> */}

                    {/* פרטי הנתמך */}
                    <div className="digital-form-section beneficiary-grid">
                        <h2>פרטי הנתמך</h2>
                        <FormField label="שם פרטי:" name="beneficiaryFirstName" value={values.beneficiaryFirstName || ''} readOnly />
                        <FormField label="שם משפחה:" name="beneficiaryLastName" value={values.beneficiaryLastName || ''} readOnly />
                        <FormField
                            label={values.beneficiaryIdType === 'passport' ? "מספר דרכון נתמך:" : "תעודת זהות נתמך:"}
                            name="beneficiaryIdNumber"
                            value={values.beneficiaryIdNumber || ''}
                            readOnly
                        />
                        <FormField label="כתובת:" name="beneficiaryAddress" value={values.beneficiaryAddress || ''} readOnly />
                        <FormField label="שם האב:" name="beneficiaryFatherName" value={values.beneficiaryFatherName || ''} readOnly />
                        <FormField label="שם האם:" name="beneficiaryMotherName" value={values.beneficiaryMotherName || ''} readOnly />
                        <FormField label="טלפון:" name="beneficiaryPhone" value={values.beneficiaryPhone || ''} readOnly />
                        <FormField label="אימייל:" name="beneficiaryEmail" value={values.beneficiaryEmail || ''} readOnly />
                    </div>
                </div>

                {/* סוג התמיכה */}
                <div className="digital-form-section">
                    <h2>תמיכה</h2>
                    <FormSelect label="סוג התמיכה:" name="supportType" value={values.supportType || ''} readOnly options={[
                        { value: '', label: 'בחר' },
                        { value: 'tuition', label: 'שכר לימוד' },
                        { value: 'welfare', label: 'סיוע ורווחה' },
                        { value: 'wedding', label: 'הכנסת כלה' },
                    ]} />
                    {/* שכר לימוד */}
                    {values.supportType === 'tuition' && (
                        <div className="digital-form-support-tuition">
                            <div className="attachments" style={{ margin: '8px 0', fontWeight: 500 }}>
                                {values.tuitionFiles && values.tuitionFiles.filter(f => f.s3Key).length > 0 && (
                                    <div className="digital-form-section">
                                        <h2>מסמכי שכר לימוד</h2>
                                        <ul>
                                            {values.tuitionFiles.filter(f => f.s3Key).map((file, idx) => (
                                                <li key={idx}>
                                                    <button type="button" onClick={() => openS3File(file.s3Key)} style={{ color: '#1976d2', textDecoration: 'underline', cursor: 'pointer', background: 'none', border: 'none', padding: 0 }}>
                                                        {decodeURIComponent(file.originalName)}
                                                    </button>
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                )}
                            </div>
                        </div>
                    )}
                    {/* סיוע ורווחה */}
                    {values.supportType === 'welfare' && (
                        <div className="digital-form-support-welfare">
                            <FormSelect
                                label="איך תתקבל התמיכה?"
                                name="welfareSupportType"
                                value={values.welfareSupportType || ''}
                                readOnly
                                options={[
                                    { value: '', label: 'בחר' },
                                    { value: 'direct', label: 'תמיכה ישירה' },
                                    { value: 'caregiver', label: 'תשלום למטפל/ת' },
                                    { value: 'products', label: 'מימון ברכישת מוצרים' },
                                ]}
                            />
                            <FormField
                                label="מספר התמיכות:"
                                name="welfareSupportCount"
                                value={values.welfareSupportCount || ''}
                                readOnly
                            />
                            <div style={{ fontWeight: 500, margin: '12px 0 4px 0' }}>למקבלים סיוע רגשי/רפואי:</div>
                            <FormField
                                label="שם מורה מקשרת"
                                name="caregiverContactName"
                                value={values.caregiverContactName || ''}
                                readOnly
                            />
                            <FormField
                                label="פלא' מורה מקשרת"
                                name="caregiverContactPhone"
                                value={values.caregiverContactPhone || ''}
                                readOnly
                            />
                        </div>
                    )}
                    {/* הכנסת כלה */}
                    {values.supportType === 'wedding' && (
                        <div className="digital-form-support-wedding">
                            <FormField label="שם החתן:" name="groomName" value={values.groomName || ''} readOnly />
                            <FormField label="ישיבה:" name="yeshiva" value={values.yeshiva || ''} readOnly />
                            <FormField label="תאריך החתונה:" name="weddingDate" value={values.weddingDate || ''} readOnly type="date" />
                            <FormField label="שם אולם:" name="weddingHall" value={values.weddingHall || ''} readOnly />
                        </div>
                    )}
                </div>

                {/* פירוט הסיבה לבקשה */}
                <div className="digital-form-section">
                    <h2>פירוט הסיבה לבקשה</h2>
                    <label className="digital-form-label">
                        פירוט הסיבה לבקשה:
                        <textarea name="requestReason" value={values.requestReason || ''} className="digital-form-textarea" readOnly />
                    </label>
                    {values.reasonFiles && values.reasonFiles.length > 0 && (
                        <div className="digital-form-section">
                            <div className="attachments" style={{ margin: '8px 0', fontWeight: 500 }}>
                                <h2>מסמכים רלוונטיים לסיבה</h2>
                                <ul>
                                    {values.reasonFiles.map((file, idx) => file.s3Key && (
                                        <li key={idx}>
                                            <button type="button" onClick={() => openS3File(file.s3Key)} style={{ color: '#1976d2', textDecoration: 'underline', cursor: 'pointer', background: 'none', border: 'none', padding: 0 }}>
                                                {decodeURIComponent(file.originalName)}
                                            </button>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        </div>
                    )}
                </div>

                {/* אופן התמיכה */}
                <div className="digital-form-section">
                    <h2>אופן התמיכה</h2>
                    <div className="digital-form-radio-group">
                        <label className="radio-rtl">
                            <input
                                type="radio"
                                name="supportPaymentType"
                                value="bank"
                                checked={values.supportPaymentType === 'bank'}
                                readOnly
                            />
                            העברה בנקאית ישירה (לנתמך או להורים)
                        </label>
                        <label className="radio-rtl">
                            <input
                                type="radio"
                                name="supportPaymentType"
                                value="supplier"
                                checked={values.supportPaymentType === 'supplier'}
                                readOnly
                            />
                            תשלום לספק (טיפול רגשי, רפואי, שוברים, מצרכים)
                        </label>
                    </div>
                    {(values.supportPaymentType === 'bank' || !values.supportPaymentType) && (
                        <div className="digital-form-bank-row">
                            <FormField label="מספר בנק:" name="bankNumber" value={values.bankNumber || ''} readOnly />
                            <FormField label="מספר סניף:" name="branchNumber" value={values.branchNumber || ''} readOnly />
                            <FormField label="מספר חשבון:" name="accountNumber" value={values.accountNumber || ''} readOnly />
                        </div>
                    )}
                    {values.supportPaymentType === 'supplier' && (
                        <div className="digital-form-supplier-row">
                            <FormField label="שם ספק:" name="supplierName" value={values.supplierName || ''} readOnly />
                            <FormField label="מס' עוסק פטור (ח.פ.):" name="supplierId" value={values.supplierId || ''} readOnly />
                            <FormField label="מספר בנק:" name="bankNumber" value={values.bankNumber || ''} readOnly />
                            <FormField label="מספר סניף:" name="branchNumber" value={values.branchNumber || ''} readOnly />
                            <FormField label="מספר חשבון:" name="accountNumber" value={values.accountNumber || ''} readOnly />
                        </div>
                    )}
                </div>

                {/* לפני כפתור שלח בקשה */}
                <div className="digital-form-section digital-form-consent-section">
                    <label className="digital-form-consent-label">
                        <input
                            type="checkbox"
                            name="charityAware"
                            checked={values.charityAware || false}
                            disabled
                            style={{ width: 18, height: 18, marginLeft: 8 }}
                        />
                        <span>אנו מודעים שהסיוע ניתן מקופת צדקה והינו מיועד לנזקקים לכך בלבד.</span>
                    </label>
                    <div className="digital-form-filler-fields">
                        <FormField label="שם פרטי של ממלא הטופס:" name="fillerFirstName" value={values.fillerFirstName || ''} readOnly />
                        <FormField label="שם משפחה של ממלא הטופס:" name="fillerLastName" value={values.fillerLastName || ''} readOnly />
                        <FormField label="קרבה לנתמך:" name="fillerRelation" value={values.fillerRelation || ''} readOnly />
                        <FormField label="טלפון ליצירת קשר:" name="fillerPhone" value={values.fillerPhone || ''} readOnly />
                        <FormField label="חתימה:" name="fillerSignature" value={values.fillerSignature || ''} readOnly />
                    </div>
                </div>
            </form>
        </div>
    );
};

export default DigitalFormView;
